import { Capacitor, registerPlugin } from '@capacitor/core';

// Plugin natif local (android/.../AppReviewPlugin.java) : fenêtre d'avis
// Google Play affichée dans l'app.
const AppReview = registerPlugin<{ requestReview(): Promise<void> }>('AppReview');

const FIRST_SEEN_KEY = 'jogolinga-review-first-seen';
const LAST_ASKED_KEY = 'jogolinga-review-last-asked';

const MIN_DAYS_SINCE_INSTALL = 2;
const MIN_DAYS_BETWEEN_ASKS = 60;
const MIN_COMPLETED_CATEGORIES = 2;
const DAY_MS = 24 * 60 * 60 * 1000;

const readNumber = (key: string): number | null => {
  try {
    const v = localStorage.getItem(key);
    return v ? Number(v) : null;
  } catch {
    return null;
  }
};

// Mémorise la date de première utilisation (appelé au démarrage).
export function markFirstSeen(): void {
  try {
    if (!localStorage.getItem(FIRST_SEEN_KEY)) {
      localStorage.setItem(FIRST_SEEN_KEY, String(Date.now()));
    }
  } catch {
    // stockage indisponible : pas de demande d'avis
  }
}

// Vrai si c'est un bon moment pour demander un avis : utilisateur engagé
// (plusieurs catégories terminées, app installée depuis quelques jours) et
// pas déjà sollicité récemment.
export function shouldAskForReview(completedCategoriesCount: number): boolean {
  if (Capacitor.getPlatform() !== 'android') return false;
  if (completedCategoriesCount < MIN_COMPLETED_CATEGORIES) return false;

  const now = Date.now();
  const firstSeen = readNumber(FIRST_SEEN_KEY);
  if (!firstSeen || now - firstSeen < MIN_DAYS_SINCE_INSTALL * DAY_MS) return false;

  const lastAsked = readNumber(LAST_ASKED_KEY);
  if (lastAsked && now - lastAsked < MIN_DAYS_BETWEEN_ASKS * DAY_MS) return false;

  return true;
}

export async function requestAppReview(): Promise<void> {
  try {
    localStorage.setItem(LAST_ASKED_KEY, String(Date.now()));
  } catch {
    // ignore
  }
  try {
    await AppReview.requestReview();
  } catch {
    // Play Store absent ou quota atteint : rien à faire
  }
}
